import type { ReactNode } from 'react';

import { Brand } from '../../../shared/ui/brand';
import { useTitle } from '../../../shared/lib/use-title';

interface IAuthScreenProps {
  title: string;
  description?: ReactNode;
  brand?: boolean;
  children: ReactNode;
  footer?: ReactNode;
}

export const AuthScreen = ({
  title,
  description,
  brand = true,
  children,
  footer,
}: IAuthScreenProps) => {
  useTitle(title);

  return (
    <div className="flex min-h-full items-center justify-center p-page">
      <div className="w-auth">
        {brand && (
          <div className="mb-10">
            <Brand />
          </div>
        )}
        <h1 className="text-display font-semibold tracking-display text-primary">{title}</h1>
        {description && <p className="mt-2 text-body text-muted">{description}</p>}
        {children}
        {footer && (
          <div className="mt-section border-t border-border-sunken pt-5 text-data text-muted">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};
